import { useContext, useEffect } from 'react';

import { RenderReadinessContext } from 'contextProviders/RenderReadinessProvider';

import { getExpectedGridExportCards } from './waitForGridExportCallbacks';

/**
 * On a scheduled render, tells RenderReadinessProvider which grid gadgets
 * haven't registered their CSV yet, so the page isn't ready until they have
 * (and the export rarely has to wait for one).
 */
const usePublishPendingCsvs = ({
  isPdfExport,
  cards,
  gridExportCallbacks,
  reportGadgetsLookup,
  dashboardGadgetsLookup,
}: {
  isPdfExport: boolean;
  cards: CanvasCard.Card[];
  gridExportCallbacks: GridExportCallback[];
  reportGadgetsLookup: Record<string, ReportGadgets.ReportGadget | undefined>;
  dashboardGadgetsLookup: Record<string, DashboardGadget | undefined>;
}) => {
  const { setPendingCsvs } = useContext(RenderReadinessContext);

  useEffect(() => {
    if (!isPdfExport) {
      return;
    }
    const registered = new Set(gridExportCallbacks.map((cb) => cb.cardI));
    setPendingCsvs(
      getExpectedGridExportCards({
        cards,
        reportGadgetsLookup,
        dashboardGadgetsLookup,
      })
        .filter((card) => !registered.has(card.cardI))
        .map((card) => card.name),
    );
  }, [
    cards,
    dashboardGadgetsLookup,
    gridExportCallbacks,
    isPdfExport,
    reportGadgetsLookup,
    setPendingCsvs,
  ]);
};

export default usePublishPendingCsvs;
